export default "__VITE_ASSET__CHGgix64__"